import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { WizardQuestionAnswer, TextAnswer } from "../wizards/wizardQuestionAnswer";
import { ContactRequestDto, QuestionAnswer } from "../dtos/contactRequestDto";

@Injectable()
export class ContactRequestService {

    constructor(private readonly http: HttpClient) { }

    convertWizardQuestionsToContactRequest(wizardQuestionAnswers: Array<WizardQuestionAnswer>, contactType: string): ContactRequestDto {
        const dto = new ContactRequestDto();

        dto.contactType = contactType;

        let name: string, phoneNumber: string, email: string;

        for (let i = 0; i < wizardQuestionAnswers.length; i++) {
            const tempName = this.findAnswer(wizardQuestionAnswers[i].textAnswers, "Full name");
            const tempTel = this.findAnswer(wizardQuestionAnswers[i].textAnswers, "Telephone number");
            const tempEmail = this.findAnswer(wizardQuestionAnswers[i].textAnswers, "Email address");
            
            if (tempName) name = tempName;
            if (tempTel) phoneNumber = tempTel;
            if (tempEmail) email = tempEmail;
            
            this.convertDataToQuestionAnswer(wizardQuestionAnswers[i], dto, contactType);
        }

        dto.fullName = name;
        dto.phoneNumber = phoneNumber;
        dto.email = email;

        return dto;
    }

    postContactRequest(contactRequestDto: ContactRequestDto) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };

        this.http.post<ContactRequestDto>("/contact-request/complete/", contactRequestDto)
            .subscribe(response => {
                
            });
            
        
    }

    private findAnswer(textAnswers: Array<TextAnswer>, value: string):string {
        const tempAnswer = textAnswers.find(x => x.question === value);

        if (tempAnswer) return tempAnswer.answer;

        return null;
    }

    private convertDataToQuestionAnswer(wizardQa: WizardQuestionAnswer, dto: ContactRequestDto, contactType: string) {
        for (let i = 0; i < wizardQa.textAnswers.length; i++) {
            const qa = new QuestionAnswer();
            qa.question = wizardQa.textAnswers[i].question;
            qa.answer = wizardQa.textAnswers[i].answer;
            dto.questionAnswers.push(qa);
        }

        if (wizardQa.selectedAnswer) {
            const qa = new QuestionAnswer();
            qa.question = wizardQa.question;
            qa.answer = wizardQa.selectedAnswer;
            dto.questionAnswers.push(qa);
        }
    }
}